export default function OverdueBanner() {
  return null; // Placeholder component
}

